import React, {useState} from 'react';
import styles from './CopyTextToClipBoardButton.module.scss';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import FileCopyRoundedIcon from '@material-ui/icons/FileCopyRounded';
import {MDBTooltip} from 'mdbreact';

interface ICopyTextToClipBoardButtonProps {
  tooltip?: string;
  copiedTooltip?: string;
  text: string;
  showCopyContent?: boolean;
  copyIcon?: any;
}

const CopyTextToClipBoardButton = (props: ICopyTextToClipBoardButtonProps) => {
    const [copied, setCopied] = useState(false);
    return (
      <MDBTooltip
        domElement
        tag="span"
        placement="top"
      >
        <span>
        <CopyToClipboard
          text={props.text}
          onCopy={() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 700);
          }}
        >
          {props.showCopyContent ?
            <span className={`${styles.copyTextToClipBoardButtonContainer} ${copied ? styles.copied : ''}`.trim()}>
            <props.copyIcon className={styles.copyIcon}/>
              {' '}
              {props.text}
          </span> : <props.copyIcon
              className={`${styles.copyTextToClipBoardButtonContainer} ${styles.copyIcon} ${copied ? styles.copied : ''} copyIcon`.trim()}/>}

        </CopyToClipboard>
        </span>
        <span>{copied ? (props.copiedTooltip || [`"${props.text}"`, "הועתק"].join(" ")) : props.tooltip}</span>
      </MDBTooltip>

    )
  }
;
CopyTextToClipBoardButton.defaultProps = {
  tooltip: 'העתק',
  text: "No text given",
  copyIcon:FileCopyRoundedIcon,
};
export default React.memo(CopyTextToClipBoardButton);
